import { AccessPermissions } from '@circlefin/permissions'
import { SynthRole } from '@services/synthetic-roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Access to view and modify blockchain approval features.
 */
export const BLOCKCHAIN_APPROVAL_MUTATION: PermissionSet = {
  access: AccessPermissions.protected,
  includeAll: [
    // Base feature flag for the new approval workflow
    SynthRole.SYNTH_NEW_APPROVAL_WORKFLOW_ONE,
    // Additional feature flag for blockchain address approval
    SynthRole.SYNTH_APPROVAL_WORKFLOW_BLOCKCHAIN_ADDRESS_ROLE,
  ],
}
